import useAsync from 'react-use/lib/useAsync';
import { assert } from '../utils';
export default function useThrowingAsync(...args) {
    const state = useAsync(...args);
    assert.ifError(state.error);
    return state;
}
//# sourceMappingURL=useThrowingAsync.js.map